export var DocumentFormats;
(function (DocumentFormats) {
    DocumentFormats["json"] = "JSON";
    DocumentFormats["csv"] = "CSV";
})(DocumentFormats || (DocumentFormats = {}));
